/** Original procedural sound: air-pressure thump, noisy shell, falling crackles.
 * No remote audio, microphone input or third-party recordings are involved. */
export function buildFireworkSound(sampleRate: number, seed: number) {
  let state = seed >>> 0;
  const random = () => { state = (Math.imul(state, 1664525) + 1013904223) >>> 0; return state / 4294967296; };
  const length = Math.round(sampleRate * 2.8);
  const samples = new Float32Array(length);
  const cracks = Array.from({ length: 19 }, (_, i) => ({ at: 0.16 + i * 0.065 + random() * 0.055, gain: (0.12 + random() * 0.2) * (1 - i / 24) }));
  let low = 0;
  let peak = 0;
  const pitch = 52 + random() * 18;
  for (let i = 0; i < length; i++) {
    const t = i / sampleRate;
    const noise = random() * 2 - 1;
    low += (noise - low) * 0.08;
    const attack = Math.min(1, t / 0.006);
    let value = attack * (low * 3.4 * Math.exp(-t * 6.5) + noise * 0.28 * Math.exp(-t * 18)
      + Math.sin(2 * Math.PI * (pitch * t + 15 * (1 - Math.exp(-t * 12)))) * 0.45 * Math.exp(-t * 7));
    for (const crack of cracks) {
      const age = t - crack.at;
      if (age >= 0 && age < 0.025) value += noise * crack.gain * Math.exp(-age * 160) * Math.min(1, age / 0.001);
    }
    // A quiet diffuse tail, not a loud repeating echo.
    for (const [delay, gain] of [[0.113, 0.15], [0.191, 0.095], [0.307, 0.055]]) {
      const back = i - Math.round(delay * sampleRate);
      if (back >= 0) value += samples[back] * gain;
    }
    value *= Math.min(1, (2.8 - t) / 0.12);
    samples[i] = value;
    peak = Math.max(peak, Math.abs(value));
  }
  for (let i = 0; i < length; i++) samples[i] *= 0.68 / Math.max(peak, 0.01);
  return samples;
}
